import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar';
import { IconClock } from '@calendly/ui/components/glyphs/IconClock';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextSecondary } from '@calendly/ui/theme';
import { summarizeInterval } from 'shared/utils';
import { BodyContainer, DateContainer, DateTimeContainer, FlexSpacer, MetadataDot, NameContainer, OwnedByContainer, StyledName, TimeContainer } from './styles';
import { getParticipantText } from '../../../meetings';
const titleTruncateCss = "tm1su8y";
const metadataTextProps = {
  color: colorTextSecondary,
  size: 'small',
  inline: true
};
const metadataDotProps = {
  ...metadataTextProps,
  inline: true,
  weight: 'semibold'
};
export const MeetingDetails = ({
  name,
  eventDate,
  eventStartTime,
  eventEndTime,
  timeNotation,
  host,
  invitees,
  source,
  isHostMeeting,
  owner,
  isListView = false
}) => {
  const isSmallPhone = useDeviceType('isSmallPhone');
  const showTime = !isSmallPhone;

  // Use the same logic as meetings page to determine what to display
  const participantText = getParticipantText({
    isHostMeeting,
    source,
    invitees,
    host
  });
  return <BodyContainer isListView={isListView}>
      <NameContainer>
        <TitleText level={3} size="medium">
          <span className={titleTruncateCss}>{name}</span>
        </TitleText>
        <StyledName isSmall>
          <FullStoryMask>
            {participantText && HtmlParser(participantText)}
          </FullStoryMask>
        </StyledName>
      </NameContainer>
      <FlexSpacer isListView={isListView} />
      <DateTimeContainer isListView={isListView}>
        <DateContainer>
          <BodyText {...metadataTextProps}>
            <UiIcon icon={IconCalendar} size="small" color={colorTextSecondary} title="" />
          </BodyText>
          <BodyText {...metadataTextProps}>
            {eventDate}
          </BodyText>
        </DateContainer>
        {showTime && <>
            <MetadataDot>
              <BodyText {...metadataDotProps}>·</BodyText>
            </MetadataDot>
            <TimeContainer>
              <BodyText {...metadataTextProps}>
                <UiIcon icon={IconClock} size="small" color={colorTextSecondary} title="" />
              </BodyText>
              <BodyText {...metadataTextProps}>
                {summarizeInterval({
              from: eventStartTime,
              to: eventEndTime
            }, timeNotation, false)}
              </BodyText>
            </TimeContainer>
          </>}
        {/* TODO(Kai/Julian/Wick): revisit owner display when external sharing lands — ensure name is available for cross-org viewers */}
        {owner?.displayName && !owner?.isCurrentUserOwner && <>
            <MetadataDot>
              <BodyText {...metadataDotProps}>·</BodyText>
            </MetadataDot>
            <OwnedByContainer data-testid="recap-owned-by">
              <BodyText {...metadataTextProps}>
                {I18n.t('publisher.meeting_recap.meeting_card.owned_by', {
              name: ''
            }).trimEnd()}
              </BodyText>
              <FullStoryExclude>
                <Avatar size="2x-small" src={owner.avatarUrl} letter={owner.avatarLetter} aria-hidden />
              </FullStoryExclude>
              <BodyText {...metadataTextProps}>
                <FullStoryMask>{owner.displayName}</FullStoryMask>
              </BodyText>
            </OwnedByContainer>
          </>}
      </DateTimeContainer>
    </BodyContainer>;
};

require("./meeting_details.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_details.js");